<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/diaporama']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'diaporama_common_name' | translate"></nz-statistic>
    </a>
</nz-card>